import { render } from "./MyStory.vue?vue&type=template&id=650f12d0&scoped=true"
import script from "./MyStory.vue?vue&type=script&lang=js"
export * from "./MyStory.vue?vue&type=script&lang=js"

import "./MyStory.vue?vue&type=style&index=0&id=650f12d0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-650f12d0"

export default script